import { useMemo } from 'react';

/**
 * Hook para isolar a lógica de cálculo das estatísticas de frequência do membro.
 */
const useAttendanceStats = (member, filteredLogs) => {
    const stats = member?.attendanceStats || {};

    const consecutiveAbsences = stats.consecutiveAbsences || 0;

    const weeklyAverageStr = useMemo(() => {
        if (!stats.presentCount || stats.presentCount <= 0 || !member?.createdAt) return "0.00";
        const createdDate = member.createdAt?.toDate ? member.createdAt.toDate() : new Date(member.createdAt);
        const daysSince = Math.floor((new Date() - createdDate) / (1000 * 60 * 60 * 24));
        const weeksActive = Math.max(1, daysSince / 7);
        return (stats.presentCount / weeksActive).toFixed(2);
    }, [stats.presentCount, member?.createdAt]);

    const periodStats = useMemo(() => {
        if (!filteredLogs) return { attended: 0, absent: 0, total: 0 };
        const attended = filteredLogs.filter(l => l.status === 'ATTENDED').length;
        const absent = filteredLogs.filter(l => l.status === 'NO_SHOW').length;
        return { attended, absent, total: filteredLogs.length };
    }, [filteredLogs]);

    return {
        consecutiveAbsences,
        weeklyAverageStr,
        periodStats
    };
};

export default useAttendanceStats;
